<!--
  ~ Copyright 2020-2023 Aion Technology LLC
  ~
  ~ Licensed under the Apache License, Version 2.0 (the "License");
  ~ you may not use this file except in compliance with the License.
  ~ You may obtain a copy of the License at
  ~
  ~     http://www.apache.org/licenses/LICENSE-2.0
  ~
  ~ Unless required by applicable law or agreed to in writing, software
  ~ distributed under the License is distributed on an "AS IS" BASIS,
  ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  ~ See the License for the specific language governing permissions and
  ~ limitations under the License.
  -->

<div class="container">
  <img src="assets/landing-page-background.png">
  <div class="hero">
    <div>WELCOME TO</div>
    <img src="assets/inspiresuccess-logo.png" alt="Inspire Success">
    <div class="mat-headline">CREATING CARING<br/>CONNECTIONS TO INSPIRE<br/>SUCCESS IN CHILDREN</div>
  </div>
  <div class="button-container">
    <div class="buttons">
      <button class="log-in" mat-flat-button [routerLink]="['/login']" *ngIf="!userLoginService.isAuthenticated">Log In</button>
      <a href="https://inspiresuccesskids.com">
        <button class="learn-more" mat-flat-button>Learn more</button>
      </a>
    </div>
  </div>
  <ms-quotes></ms-quotes>
</div>
